// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@babel/polyfill';
import axios from 'axios';
import 'url-polyfill';
import Vue from 'vue';
import VueCookie from 'vue-cookie';
import Meta from 'vue-meta';
import Vuelidate from 'vuelidate';
import App from './App';
import checkoutApi from './plugins/CheckoutAPI';
import i18n from './plugins/i18n';
import router from './router';
import store from './store';
import * as ModalDialogs from 'vue-modal-dialogs';
import dialog from './plugins/dialog-helper';
import VTooltip from 'v-tooltip';
import a2s from './plugins/a2s';

Vue.use(checkoutApi);
Vue.use(Meta);
Vue.use(VueCookie);
Vue.prototype.$http = axios;
Vue.prototype.$eventBus = new Vue();
Vue.use(Vuelidate);
Vue.use(ModalDialogs);
Vue.use(dialog);
Vue.use(VTooltip);
Vue.use(a2s);

axios.interceptors.response.use(
	(response) => {
		if (response && response.data && response.data.sandbox === true) {
			store.commit('enableSandboxMode');
		}
		return response;
	},
	(error) => {
		return Promise.reject(error);
	} // eslint-disable-line arrow-body-style
);

axios.interceptors.request.use(
	(request) => {
		if (store.state.sandboxMode) {
			if (!request.params) request.params = {};
			request.params.sandbox = 'true';
		}
		return request;
	},
	(error) => error
);

Vue.config.productionTip = false;

Vue.mixin({
	props: {
		locale: {
			type: String,
			default: '',
		},
	},
	computed: {
		region() {
			return environment.region;
		},
	},
	methods: {
		replaceUrlLocale(url, pos = 3) {
			try {
				const urlArray = /^http[s]?:\/\/([^:/\s]+)\/(\w+)\/(\w+)/g.exec(url);
				if (
					!this.$i18n.locale ||
					this.$i18n.locale === urlArray[pos] ||
					!Object.keys(this.$i18n.messages).includes(urlArray[pos])
				)
					return url; // verify a locale code
				return url.replace(
					`${urlArray[pos - 1]}/${urlArray[pos]}`,
					`${urlArray[pos - 1]}/${this.$i18n.locale}`
				);
			} catch (e) {
				return url;
			}
		},
		isSafeUrl(url) {
			if (!url) return false;
			try {
				const hostName = new URL(url).hostname;
				if (process.env.VUE_APP_ENV === 'dev') {
					return (
						hostName.endsWith('localhost') ||
						hostName.endsWith('.nexon.com') ||
						hostName.endsWith('.nexon.net') ||
						hostName.endsWith('0.0.0.0')
					);
				}
				return (
					hostName.endsWith('.nexon.com') || hostName.endsWith('.nexon.net') || hostName.endsWith('0.0.0.0')
				);
			} catch {
				return false;
			}
		},
		goto(url) {
			const safeUrl = url
				.replace(' ', '')
				.replace('(\n)', '')
				.replace(';', '&semi;')
				.replace('<', '&lt;')
				.replace('>', '&gt;')
				.replace('(', '&lpar;')
				.replace(')', '&rpar;')
				.replace(/'/g, '&apos;')
				.replace(/"/g, '&quot;');
			if (!this.isSafeUrl(safeUrl)) return;
			window.location.replace(this.replaceUrlLocale(safeUrl));
		},
	},
});

/* eslint-disable no-new */
new Vue({
	el: '#app',
	i18n,
	router,
	store,
	components: { App },
	data() {
		return {
			getData: {},
			error: {},
			totalPaymentAmount: null,
			afterBalanceWithRequirePayment: null,
		};
	},
	mounted() {
		this.$a2s.init();
	},
	render: (h) => h(App),
});
